export default {
  InvdSeq: 0,
  InvhSeq: 0,
  GroupNo: 1,
  InvdNo: 0,
  InvdDesc: "",
  InvdRemark: "",
  DeptCode: "",
  CrDept: "",
  CrAcc: "",
  DrDept: "",
  DrAcc: "",
  Qty: 1,
  Unit: "",
  Price: 0,
  NetAmt: 0,
  NetBaseAmt: 0,
  TotalAmt: 0,
  TotalBaseAmt: 0,
  TaxDept1: "",
  TaxAcc1: "",
  TaxType1: "None",
  TaxRate1: 0,
  TaxAmt1: 0,
  TaxBaseAmt1: 0,
  Tax1Overwrite: false,
  TaxDept2: "",
  TaxAcc2: "",
  TaxType2: "None",
  TaxRate2: 0,
  TaxAmt2: 0,
  TaxBaseAmt2: 0,
  Tax2Overwrite: false,
  Unpaid: 0,
  Paid: 0,
  PfmSeq: null,
  InvdDate: new Date(),
  UserModified: localStorage.getItem("UserName"),
  DimList: {
    Dim: [],
  },
};
